import React from 'react';

import { useTheme } from '../../context/ThemeContext';

interface ReduxLogoProps {}

export const ReduxLogo = ({ ...props }: ReduxLogoProps) => {
  const { activeTheme } = useTheme();
  return (
    <>
      <div className="logo-container">
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M69.2894 68.6456C72.9798 68.2638 75.7794 65.0824 75.6521 61.2646C75.5249 57.4468 72.3435 54.3926 68.5259 54.3926H68.2714C64.3265 54.5199 61.2724 57.8286 61.3997 61.7736C61.5269 63.6825 62.2905 65.3369 63.4357 66.4822C59.1091 75.0085 52.4919 81.2442 42.5661 86.4618C35.8216 90.0251 28.8226 91.2977 21.8236 90.4069C16.0972 89.6433 11.6433 87.0981 8.84369 82.8986C4.77155 76.6629 4.38979 69.9182 7.82565 63.1735C10.2435 58.3376 14.0611 54.7744 16.4789 52.9928C15.9699 51.3384 15.2064 48.5387 14.8246 46.5026C-3.62722 59.8647 -1.71841 77.9355 3.88077 86.4618C8.08016 92.8248 16.6062 96.7698 26.023 96.7698C28.5681 96.7698 31.1132 96.5153 33.6583 95.879C49.9468 92.6975 62.2905 83.0259 69.2894 68.6456ZM91.6862 52.8655C82.0149 41.5395 67.7624 35.3038 51.4738 35.3038H49.4378C48.2925 33.0131 45.8747 31.486 43.2023 31.486H42.9478C39.0029 31.6133 35.9488 34.922 36.0761 38.867C36.2033 42.6848 39.3847 45.739 43.2023 45.739H43.4568C46.2564 45.6118 48.6743 43.8301 49.6923 41.4122H51.9829C61.6542 41.4122 70.8165 44.2119 79.088 49.684C85.4507 53.8836 90.0319 59.3557 92.577 65.9732C94.7403 71.318 94.613 76.5357 92.3224 80.9897C88.7593 87.7344 82.7784 91.4249 74.8886 91.4249C69.7984 91.4249 64.9628 89.8978 62.4177 88.7525C61.0179 90.0251 58.4728 92.0612 56.6913 93.3338C62.1632 95.879 67.7624 97.2788 73.1071 97.2788C85.3235 97.2788 94.3585 90.5341 97.7944 83.7894C101.485 76.4084 101.23 63.6825 91.6862 52.8655ZM27.041 70.809C27.1683 74.6268 30.3496 77.681 34.1673 77.681H34.4218C38.3667 77.5537 41.4208 74.245 41.2935 70.3C41.1663 66.4822 37.9849 63.428 34.1673 63.428H33.9128C33.6583 63.428 33.2765 63.428 33.022 63.5553C27.8046 54.9016 25.6412 45.4845 26.4048 35.3038C26.9138 27.6683 29.4589 21.0508 33.9128 15.5787C37.6031 10.8701 44.7294 8.57943 49.565 8.45217C63.054 8.19766 68.7804 24.9958 69.1622 31.7405C70.8165 32.1223 73.6161 33.0131 75.5249 33.6494C73.9978 13.0335 61.2724 2.34375 49.056 2.34375C37.6031 2.34375 27.041 10.6156 22.8417 22.8324C16.988 39.1216 20.8056 54.7744 27.9318 67.1185C27.2955 68.0093 26.9138 69.4092 27.041 70.809Z"
            fill={activeTheme === 'light' ? '#2F2F3A' : '#ffffff'}
          />
        </svg>

        <p style={{ color: activeTheme === 'light' ? '#2F2F3A' : '#ffffff' }}>
          Redux
        </p>
      </div>
    </>
  );
};

export default ReduxLogo;
